import { useContext, useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { GlobalContext } from '../../../Providers/GlobalProvider'

const SpecialityYearsSelector = ({ className = '', empty = false, disabled, multiple = 'default', reverse = false, style = {}, values = [], dropdownRender, onChange }) => {
  const { specialityYears } = useContext(GlobalContext)

  const entityOptions = useMemo(() => specialityYears.map(sy => {
    return {
      value: sy.id,
      entity: sy,
      label: `${sy.specialityAbbreviation} (${sy.studyYearName})`,
      tooltip: `${sy.specialityName} (${sy.studyYearName})`
    }
  }), [specialityYears, reverse])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={entityOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default SpecialityYearsSelector
